<script>
import freeeForm from './_freee'

export default {
  name: "TenantProviderEdit",
  components: {
    freeeForm
  },
  data() {
    return {
      breadcrumbs: [
        { text: '契約情報', disabled: false, to: '/driver/masters/tenants', exact: true },
        { text: '外部サービス連携', disabled: true, to: '' },
      ],
      provider: null,
    }
  },
  created() {
    this.provider = this.$route.params.provider
  },
}
</script>

<template>
  <v-container >
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />

    <freee-form v-if="provider === 'freee'" :provider="provider" />

  </v-container>
</template>

<style scoped lang="scss">

</style>
